import { render, staticRenderFns } from "./highlightMostDefectPartChart.vue?vue&type=template&id=240c567b&scoped=true&"
import script from "./highlightMostDefectPartChart.vue?vue&type=script&lang=js&"
export * from "./highlightMostDefectPartChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240c567b",
  null
  
)

export default component.exports